import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import {
  FormGroup,
  ControlContainer,
  FormGroupDirective,
} from '@angular/forms';
import { InputField } from '../../../core/models/input-field';

@Component({
  selector: 'app-multi-select',
  templateUrl: './multi-select.component.html',
  viewProviders: [
    {
      provide: ControlContainer,
      useExisting: FormGroupDirective,
    },
  ],
})
export class MultiSelectComponent implements OnInit {
  /**
   * * General
   * @errors Form control errors
   * @specificFormGroup Set custom form group
   */
  errors: any = {};
  specificFormGroup: FormGroup;
  /**
   * * Inputs
   * @options Configuration for this form field
   * @customFormGroup Used when you want to use this component without form-builder
   */
  @Input() options: InputField;
  @Input() customFormGroup: any;
  /**
   * * Outputs
   * @handleChange Event when item in dropdown is selected
   */
  @Output() handleChange = new EventEmitter<any>();

  constructor(public controlContainer: ControlContainer) {}

  /* ====================================
  *              LIFECYCLES
  ======================================= */

  ngOnInit(): void {
    if (
      this.options?.fieldFormGroup != '' &&
      this.options?.fieldFormGroup != undefined
    ) {
      this.specificFormGroup =
        this.options?.fieldFormGroup !== ''
          ? this.getSpecificFormGroup(this.options?.fieldFormGroup)
          : this.customFormGroup;
    } else {
      this.specificFormGroup = this.customFormGroup;
    }
  }

  /* ====================================
  *                HELPERS
  ======================================= */

  onChangeValue(value: any) {
    this.handleChange.emit(value);
  }

  getSpecificFormGroup(formGroupPath: string) {
    return <FormGroup>this.customFormGroup.get(formGroupPath);
  }
}
